import React from 'react';
import {
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles((theme) => {
  return {
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    dialogContent: {
      width: '100%',
      height: '100%',
    }
  };
});

export default function MerchantStatus({ affiliate, isOpen, onClose }) {
  const classes = useStyles();

  return (
    <Dialog
      open={isOpen}
      fullWidth
      maxWidth="md"
      onClose={onClose}
      aria-labelledby="confirm-dialog"
    >
      <DialogTitle id="confirm-dialog">
        <Typography variant="h3">DermPRO Affiliate Program</Typography>
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <div className="p-10 mb-5 border-1-muted border-radius-8">
          <Typography className="text-dark-gray text-16">
            Status: <span className="text-20 text-primary font-bold">PENDING</span>
          </Typography>
          <Typography className="text-dark-gray text-16">
            Your application is now under review with the affiliate marketing program for {affiliate.name}.
            Once approved, you’ll have immediate use of banners and links to earn money from your website.
            Search for more while you wait!
          </Typography>
        </div>
      </DialogContent>
    </Dialog>
  );
}
